import * as v from "valibot";
import type { FormErrorCodes, PaymentKitErrors, PaymentKitFields } from "../types";

type Options = {
  optionalZipCode?: boolean;
};

export const validateFormFields = async (fields: PaymentKitFields, options: Options = {}) => {
  const schema = v.object({
    customer_name: v.pipe(
      v.string("required"),
      v.nonEmpty("required"),
      v.minLength(4, "invalid"),
      v.maxLength(40, "invalid"),
    ),
    customer_email: v.pipe(v.string("required"), v.nonEmpty("required"), v.email("invalid")),
    customer_country: v.pipe(v.string("required"), v.nonEmpty("required")),
    customer_zip_code: options.optionalZipCode
      ? v.pipe(v.string("required"))
      : v.pipe(v.string("required"), v.nonEmpty("required")),
  });

  const result = v.safeParse(schema, fields);

  if (result.issues) {
    const errors = result.issues.reduce((errors, issue) => {
      const field = v.getDotPath(issue) as keyof PaymentKitErrors;

      errors[field] = issue.kind === "schema" ? "required" : (issue.message as FormErrorCodes);
      return errors;
    }, {} as PaymentKitErrors);
    return { isSuccess: false, errors };
  }

  return { isSuccess: true, errors: {} as PaymentKitErrors };
};
